import UserManegmentPage from './UserManegmentPage';

export default UserManegmentPage;
